import OrganizationBusy from '@auth/OrganizationBusy'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

export const Route = createFileRoute('/login/organization-busy')({
  component: RouteComponent,
  validateSearch: z.object({
    to: z.string().optional(),
  }),
})

function RouteComponent() {
  const { to } = Route.useSearch()

  return <OrganizationBusy to={to} />
}
